// function refreshCart(cart) {

//   $cartBtn = $(".icon-cart");

//   if ($cartBtn) {
//     var $cartCount = $cartBtn.find(".cart_count");
//     var value = $cartCount.text() || "0";
//     var cart_items_html = "";
//     var $cart = $("#cart ul");

//     if ($cartCount && $cartCount.length) {
//       $cartCount.text(value.replace(/[0-9]+/, cart.item_count));
//     } else {
//       $cartBtn.prepend(
//         '<div class="cart_count">' + cart.item_count + "</div>"
//       );
//     }

//     $cart.find("li:not(:first)").remove();

//     if (cart.item_count == 0) {

//       $cart.append(
//         '<li class="mm-label empty_cart"><a href="/cart">Your Cart is Empty</a></li>'
//       );
//       $cartCount.remove();

//     } else {

//       $.each(cart.items, function(index, item) {

//         var line_id = index + 1;

//         cart_items_html +=
//           '<li class="cart_item">' +
//           '<p class="mm-counter quantity_selector">' +
//           '<span class="minus">-</span>' +
//           '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' +
//           item.id +
//           '" value="' +
//           item.quantity +
//           '"  data-line-id="' +
//           line_id +
//           '" readonly />' +
//           '<span class="plus">+</span>' +
//           "</p>" +
//           '<a href="' +
//           item.url +
//           '">';

//     var itemImage = item.image;

//         if (item.properties && item.properties['_image'] !== undefined) {

//       cart_items_html +=
//             '<div class="cart_image">' +
//             '<img src="' +
//             item.properties['_image'] +
//             '" alt="' +
//             htmlEncode(item.title) +
//             '" />' +
//             "</div>";

//         } else if (item.image) {

//           cart_items_html +=
//             '<div class="cart_image">' +
//             '<img src="' +
//             item.image
//           .replace(/(\.[^.]*)$/, "_medium$1")
//           .replace("http:", "") +
//             '" alt="' +
//             htmlEncode(item.title) +
//             '" />' +
//             "</div>";

//         }

//         cart_items_html += '<div class="item_info">' + item.title;

//         if (item.properties) {

//           $.each(item.properties, function(title, value) {
//             if (value && !title.startsWith('_')) {
//               cart_items_html +=
//                 '<div class="line-item">' + title + ": " + value + "</div>";
//             }
//           });

//         }

//         cart_items_html +=
//           '<div class="price"><span class="money">' +
//           Shopify.formatMoney(item.price, $cart.data("money-format")) +
//           "</span></div></div></a></li>";
//       });

//       cart_items_html +=
//         '<li class="mm-label">' +
//         '<p class="mm-counter"><span class="money">' +
//         Shopify.formatMoney(cart.total_price, $cart.data("money-format")) +
//         "</span></p>" +
//         '<a href="/cart">' +
//         "<strong>Subtotal</strong>" +
//         "</a>" +
//         "</li>" +
//         '<li class="mm-subtitle clearfix">';

//       var cart_note = cart.note ? cart.note : "";
//       cart_items_html +=
//         '<textarea id="note" name="note" rows="2" placeholder="Order Notes" class="clearfix">' +
//         cart_note +
//         "</textarea>";

//       cart_items_html +=
//         '<input type="submit" class="action_button right" value="Checkout" />' +
//         '<a href="/cart" class="action_button edit_cart left">Edit Cart</a>' +
//         "</li>";

//       $cart.append(cart_items_html);

//       convertCurrencies();

//     }
//   }
// }


// function afterAddToCart() {

//   debugger;
//   $.ajax({
//     url: '/cart.js',
//     dataType: "json",
//     cache: false,
//     success: function(cart) {

//       refreshCart(cart);
//       window.setTimeout(function(){ $.fancybox.close(); $('.cart-button').click(); }, 500);

//     }

//   });

// }

// var $cart = $('#cart');

// if ($cart && $cart.length > 0) {

//   document.addEventListener('AFTER_ADD_TO_CART', function (e) {
//   afterAddToCart();
//   }, false);

// }


function tooltips() {
    if (iOS()) {
      $(".cpb-option").each((i, option) => {
        if (option.classList.contains('cpb-option-type-text')) return
        const optionId = option.dataset.optionId;
  
        let optionPrice, optionLabel;
  
        CPB.getStore()
          .getState()
          .Product.panels.find((panel) =>
            panel.categories.find((category) =>
              category.options.find((option) => {
                if (option.id === optionId) {
                  optionPrice = option.price == 0 ? '' : ' ' + Shopify.formatMoney(option.price);
                  optionLabel = option.option.data.label;
                }
              })
            )
          );
          
        tippy(option, {
          content: optionLabel + optionPrice,
          trigger: "click",
          zIndex: 10,
          placement: "bottom",
          flipOnUpdate: true,
          boundary: "window",
        });
      });
    }
  
    function iOS() {
      var iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ];
  
      if (!!navigator.platform) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            return true;
          }
        }
      }
  
      return false;
    }
}

document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', tooltips);
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', tooltips);